var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.buttonName)?_c('a',{staticClass:"location-button-bottom",style:(_vm.style),attrs:{"href":`#${_vm.formId}`},on:{"click":_vm.onClick}},[_c('i',{staticClass:"iconfont iconbiaodan"}),_c('span',[_vm._v(_vm._s(_vm.buttonName))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }